import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getSubCategories,
  createSubCategory,
  updateSubCategory,
  deleteSubCategory,
  uploadLearningCategoryImage,
  getCoursePreview,
  getBreadCrumbInformation,
  removePreview,
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import { showSuccessToastMessage, showErrorToastMessage, emptyCheck, isInt } from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import * as CONSTANT from "../../../../constants";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";
import ReactCrop from "react-image-crop";
import PreviewModal from "../Common/PreviewModal";

class AdminLearningCategories extends Component {
  state = {
    moduleName: "",
    mastersubcategories: [],
    subcategories: [],
    selectedSubCategory: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: "",
    src: null,
    crop: {
      unit: "%",
      x: 0,
      y: 0,
      width: 50,
      height: 50,
      aspect: 244 / 187,
    },
    previewUrl: "",
    previewTitle: "",
    filePath: "",
  };
  componentDidMount() {
    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
        value: function (callback, type, quality) {
          var canvas = this;
          setTimeout(function () {
            var binStr = atob(canvas.toDataURL(type, quality).split(",")[1]),
              len = binStr.length,
              arr = new Uint8Array(len);

            for (var i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], { type: type || "image/png" }));
          });
        },
      });
    }
    this.getBreadCrumbInformationFromService();
    this.getSubCategoriesFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow,
    });
  }

  getCategoryId() {
    return this.props.match.params.learningid;
  }

  getModuleId() {
    return this.props.match.params.moduleid;
  }

  getSubCategoriesFromService() {
    this.showSpinner(true);
    getSubCategories(this.getCategoryId())
      .then((response) => {
        this.setState({ subcategories: response.data, mastersubcategories: response.data });
        this.showSpinner(false);
      })
      .catch((error) => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }

  getBreadCrumbInformationFromService() {
    getBreadCrumbInformation(this.getModuleId(), null, null).then((response) => {
      this.setState({ moduleName: response.data.Module });
    });
  }

  editSubCategory(subcategory) {
    this.imageRef = null;
    this.setState({
      src: null,
      croppedImageUrl: null,
      action: "edit",
      selectedSubCategory: subcategory,
      showModal: true,
      errorMessage: "",
      crop: {
        unit: "%",
        x: 0,
        y: 0,
        width: 50,
        height: 50,
        aspect: 244 / 187,
      },
    });
  }

  deleteSubCategory(subcategory) {
    this.imageRef = null;
    this.setState({
      src: null,
      croppedImageUrl: null,
      action: "delete",
      selectedSubCategory: subcategory,
      showDeleteModal: true,
      crop: {
        unit: "%",
        x: 0,
        y: 0,
        width: 50,
        height: 50,
        aspect: 244 / 187,
      },
    });
  }

  addSubCategory() {
    const maxOrder =
      this.state.subcategories.length > 0 ? Math.max(...this.state.subcategories.map((o) => o.Order)) : 0;
    let nextOrder = maxOrder + 1;
    this.imageRef = null;
    this.setState({
      action: "add",
      croppedImageUrl: null,
      src: null,
      selectedSubCategory: { Order: nextOrder },
      showModal: true,
      errorMessage: "",
      crop: {
        unit: "%",
        x: 0,
        y: 0,
        width: 50,
        height: 50,
        aspect: 244 / 187,
      },
    });
  }
  onHideModal() {
    this.imageRef = null;
    this.setState({
      showModal: false,
      croppedImageUrl: null,
      src: null,
      crop: {
        unit: "%",
        x: 0,
        y: 0,
        width: 50,
        height: 50,
        aspect: 244 / 187,
      },
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false,
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "SubCategory");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }
  validate(data) {
    console.log(data);
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    if (emptyCheck(data.Order)) {
      this.setState({ errorMessage: "Order cannot be blank" });
      return false;
    }
    if (!isInt(data.Order)) {
      this.setState({ errorMessage: "Order only accepts numerical values" });
      return false;
    }
    const uploadedFile = document.getElementById("file");
    if (uploadedFile.files.length === 0 && this.state.action === "add") {
      this.setState({ errorMessage: "Please upload an image" });
      return false;
    }
    const { croppedImageUrl } = this.state;
    if (this.state.action === "add" && (croppedImageUrl === "" || croppedImageUrl === null)) {
      console.log("croppedImageUrl", croppedImageUrl);
      this.setState({ errorMessage: "Please crop the image using cropping tool" });
      return false;
    }
    return true;
  }
  saveSubCategory = async () => {
    debugger;
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedSubCategory.Id : 0,
      Name: this.refs["txtSubCategory"].value,
      Order: this.refs["txtOrder"].value,
      CategoryId: this.props.match.params.learningid,
      Tid: this.state.action === "edit" ? this.state.selectedSubCategory.Tid : 0,
      ImagePath: this.state.action === "edit" ? this.state.selectedSubCategory.ImagePath : "",
      IsEnabled: true, //this.refs["chkIsEnabled"].checked
    };
    if (this.validate(data)) {
      const uploadedFile = document.getElementById("file");
      let blob = await fetch(this.state.croppedImageUrl).then((r) => r.blob());
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          let formdata = new FormData();
          formdata.append("file", blob, "newfile.jpg"); //uploadedFile.files[0]);
          uploadLearningCategoryImage(formdata)
            .then((resFilePath) => {
              data.ImagePath = resFilePath.data;
              console.log(resFilePath);
              createSubCategory(data)
                .then((response) => {
                  this.showSpinner(false);
                  console.log(response);
                  this.onHideModal();
                  this.showSuccessMessage(data.Name);
                  this.getSubCategoriesFromService();
                })
                .catch((error) => {
                  this.showSpinner(false);
                  console.log(error);
                  this.showErrorMessage(error);
                  this.onHideModal();
                });
            })
            .catch((error) => {
              this.showSpinner(false);
              this.showErrorMessage(error);
              console.log(error);
            });
          break;
        case "edit":
          this.showSpinner(true);
          if (uploadedFile.files.length > 0) {
            let formdata = new FormData();
            // formdata.append("file", uploadedFile.files[0]);
            formdata.append("file", blob, "newfile.jpg");
            uploadLearningCategoryImage(formdata)
              .then((resFilePath) => {
                data.OldImagePath = data.ImagePath;
                data.ImagePath = resFilePath.data;
                console.log(resFilePath);
                this.updateSubCategoryService(data);
              })
              .catch((error) => {
                this.showSpinner(false);
                this.showErrorMessage(error);
                console.log(error);
              });
          } else {
            this.updateSubCategoryService(data);
          }

          break;
        default:
          break;
      }
    }
  };

  updateSubCategoryService(data) {
    updateSubCategory(data)
      .then((response) => {
        this.showSpinner(false);
        console.log(response);
        this.onHideModal();
        this.showSuccessMessage(data.Name);
        this.getSubCategoriesFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
        this.onHideModal();
      });
  }

  confirmDeleteSubCategory() {
    this.showSpinner(true);
    deleteSubCategory(this.state.selectedSubCategory.Id)
      .then((response) => {
        this.showSpinner(false);
        console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedSubCategory.Name);
        this.getSubCategoriesFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleSubCategoryChange = (event) => {
    let selectedSubCategory = this.state.selectedSubCategory;
    selectedSubCategory.Name = event.target.value;
    this.setState({ selectedSubCategory: selectedSubCategory });
  };

  manageVideoCategories(subcategory) {
    this.props.history.push(
      `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/learningvideocategories/` +
        subcategory.Id
    );
  }

  manageAssignment(subcategory) {
    this.props.history.push(
      `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/assessment/` + subcategory.Id
    );
  }
  handleSearchTermChange = (event) => {
    let filteredSubCategories = this.state.mastersubcategories.filter((d) => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        subcategories: filteredSubCategories,
        searchTerm: event.target.value,
      });
    else
      this.setState({
        subcategories: this.state.mastersubcategories,
        searchTerm: event.target.value,
      });
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => this.setState({ src: reader.result }));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, "newFile.jpeg");
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  onHidePreviewModal() {
    removePreview(this.state.filePath);
    this.setState({
      showPreviewModal: false,
    });
  }

  goToPreviewCourse = (value) => {
    console.log("value", value);

    this.showSpinner(true);
    getCoursePreview(this.getModuleId())
      .then((response) => {
        const url = (
          CONSTANT.API_BASE_URL.substring(0, CONSTANT.API_BASE_URL.length - 1) +
          response.data +
          `?subcategoryid=${value.Id}`
        ).replace("index.html?preview=1", "video.html");

        this.setState({
          filePath: response.data.replace("index.html?preview=1", ""),
          showPreviewModal: true,
          previewUrl: url,
          previewTitle: `${value.Name} (Preview Mode)`,
        });
        this.showSpinner(false);
      })
      .catch((error) => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  };

  render() {
    const { crop, src, croppedImageUrl, moduleName } = this.state;

    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">Learning Categories</h1>
        <AdminBreadcrumb
          data={[
            { name: "Home", link: "/admin/modules/" },
            { name: moduleName, link: "/admin/modules/" },
            // { name: "Categories", link: `/admin/${this.props.match.params.moduleid}/categories/` },
            { name: "Learning Categories" },
          ]}
        />
        <button className="btn btn-default add-btn" onClick={() => this.addSubCategory()}>
          Add Learning Category
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Name", "Image", "Order"]}
          values={this.state.subcategories}
          indexName="Id"
          properties={["Id", "Name", "ImagePath", "Order", "Action"]}
          edit={(value) => this.editSubCategory(value)}
          delete={(value) => this.deleteSubCategory(value)}
          extraActions={[(value) => this.manageVideoCategories(value), (value) => this.goToPreviewCourse(value)]}
          extraActionNames={["Manage Content Categories", "Preview"]}
        />
        {/* extraActions={[value => this.manageVideoCategories(value), value => this.manageAssignment(value)]} */}
        {/* extraActionNames={["Manage Video Categories", "Assessment"]} */}
        <AddEditModal
          dialogClassName={"modal-90w"}
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveSubCategory()}
          form={this.addeditform}
          type="Learning Category"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtSubCategory"
              defaultValue={this.state.selectedSubCategory.Name}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Image:
            </label>
            <input id="file" type="file" className="form-control" ref="fileSubCategory" onChange={this.onSelectFile} />
            {src && (
              <div>
                <div>
                  <span style={{ color: "red" }}>
                    Reposition or resize the square indicator below and click the save button beneath it to store your
                    image.
                  </span>
                </div>
                <ReactCrop
                  // locked={true}
                  minWidth="244"
                  minHeight="187"
                  src={src}
                  crop={crop}
                  ruleOfThirds
                  onImageLoaded={this.onImageLoaded}
                  onComplete={this.onCropComplete}
                  onChange={this.onCropChange}
                />
              </div>
            )}
            {/* {croppedImageUrl && (
              <div>
                <div>
                  <strong>Preview:</strong>
                </div>
                <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
              </div>
            )} */}
          </div>

          {croppedImageUrl === null && this.state.action === "edit" && (
            <div>
              <img src={CONSTANT.API_BASE_URL + this.state.selectedSubCategory.ImagePath} alt="learningcategoryimage" />
            </div>
          )}
          {/* <div className="form-group">
            <label>Is Enabled?:</label>
            <input
              type="checkbox"
              className="chkBoxCustom"
              ref="chkIsEnabled"
              defaultChecked={this.state.selectedSubCategory.IsEnabled}
            />
          </div> */}
          <div className="form-group">
            <label>
              <RequiredField />
              Order:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtOrder"
              defaultValue={this.state.selectedSubCategory.Order}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedSubCategory.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteSubCategory()}
          name={this.state.selectedSubCategory.Name}
          type="Learning Category"
        />
        <PreviewModal
          title={this.state.previewTitle}
          url={this.state.previewUrl}
          showModal={this.state.showPreviewModal}
          onHideModal={() => this.onHidePreviewModal()}
        />
      </Aux>
    );
  }
}

export default AdminLearningCategories;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/LearningCategories/LearningCategories.js